import { z } from 'zod';

export const filterSchema = z.object({
  region_id: z.string(),
  district_id: z.string(),
  farmer: z.string(),
  inn: z.string(),
  contour_number: z.string(),
  cadastre: z.string(),
  reg_number: z.string(),
  area_from: z.string(),
  area_to: z.string(),
  crop_id: z.string(),
  plant_id: z.string(),
  year: z.string(),
  project_month: z.string(),
  project_action_id: z.array(z.string()),
  project_status: z.string(),
});

export type FilterFormValue = z.infer<typeof filterSchema>;
